import { BaseObject } from "../core/BaseObject";

export class AttachmentTypeDto extends BaseObject {
    attachmentTypeId: number;
    name: string;
}
